import { render } from "./FacultySpecialDeloadingDialog.vue?vue&type=template&id=c433155e"
import script from "./FacultySpecialDeloadingDialog.vue?vue&type=script&lang=js"
export * from "./FacultySpecialDeloadingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__